export enum DefaultMealTime {
    BREAKFAST = 0,
    LUNCH = 11
}